<template>
   <div class="control">
     <section class="generating-label" v-if="progress !== 0">
                <span class="label-title">
                    {{ progress === 100 ? 'PDF Generated' : 'Generating PDF' }}
                </span>

       <span class="label-progress">
                    {{ `${ progress } %` }}
                </span>
     </section>
     <button
         :disabled="isGenerating"
         class="btn btn-success"
         @click="$emit('generateReport')"
     >
       {{ isGenerating ? 'Loading...' : 'Generate PDF' }}
     </button>
   </div>

</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props: {
        progress: {
            type: Number,
            default: 0
        }
    },

    data () {
        return {
            controls: [
				{
					label: 'show-layout:',
					type: 'Boolean',
                    options: 'true, false',
                    inputType: 'checkbox',
                    vModel: 'showLayout'
                },

                {
					label: 'float-layout:',
					type: 'Boolean',
                    options: 'true, false',
                    inputType: 'checkbox',
                    vModel: 'floatLayout'
                },

                {
					label: 'enable-download:',
					type: 'Boolean',
                    options: 'true, false',
                    inputType: 'checkbox',
                    vModel: 'enableDownload'
                },

                {
					label: 'preview-modal:',
					type: 'Boolean',
                    options: 'true, false',
                    inputType: 'checkbox',
                    vModel: 'previewModal'
                },

                {
					label: 'manual-pagination:',
					type: 'Boolean',
                    options: 'true, false',
                    inputType: 'checkbox',
                    vModel: 'manualPagination'
                },
                
                {
					label: 'paginate-elements-by-height:',
					type: 'Number',
                    options: 'Any Number',
                    inputType: 'number',
                    vModel: 'paginateElementsByHeight'
                },
                
                {
					label: 'filename:',
					type: 'String',
                    options: 'Any String',
                    inputType: 'text',
                    vModel: 'filename'
                },
                
                {
					label: 'pdf-quality:',
					type: 'Number',
                    options: '0 - 2 (Can Have Decimal)',
                    inputType: 'number',
                    vModel: 'pdfQuality'
                },

                {
					label: 'pdf-format:',
					type: 'String',
                    options: 'a0, a1, a2, a3, a4, letter, legal, a5, a6, a7, a8, a9, a10',
                    inputType: 'text',
                    vModel: 'pdfFormat'
                },
                
                {
					label: 'pdf-orientation:',
					type: 'String',
                    options: 'portrait, landscape',
                    inputType: 'text',
                    vModel: 'pdfOrientation'
                },
                
                {
					label: 'pdf-content-width:',
					type: 'String',
                    options: 'Any css sizes (e.g. "800px", "65vw", "70%")',
                    inputType: 'text',
                    vModel: 'pdfContentWidth'
				},
            ],
        }
    },

    computed: {
        ...mapFields([
            'controlValue'
        ]),

        isGenerating () {
            return this.progress !== 0 && this.progress !== 100
        }
    },

    methods: {
        setInput (e, key, inputType) {
            let value = e.target.value

            if (inputType === 'checkbox') {
                value = e.target.checked
            }

            if (inputType === 'number') {
                value = e.target.value
                            ? parseFloat(e.target.value)
                            : 0
            }

            this.$set(this.controlValue, key, value)
        }
    },
}
</script>

<style lang="scss" scoped>
.control {

}
</style>
